'use strict';
import React, { useState, useRef } from "react";
import { Camera } from "react-camera-pro";
import * as classes from './MyCamera.module.css';
import IconButton from '@mui/material/IconButton';
// import Button from '@mui/material-next/Button';
// import IconButton from '@material-ui/core/IconButton';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import Cameraswitch from '@mui/icons-material/Cameraswitch';


import { Buffer } from 'buffer';
global.Buffer = Buffer;

import axios from 'axios';

import quick_dirty_string_checksum from './security/security.js'

const MyCamera = () => {
  const camera = useRef(null);
  const [image, setImage] = useState(null);
  const [numberOfCameras, setNumberOfCameras] = useState(0);


  // reafactor crystalise along `fetchUserMLResults()`
  async function oneGo(photo, user_id) {
    // not used I think:
    // const mimeType = 'image/jpg';
    //const mimeType = 'image/png';
    const multiPartContent = [photo];

    // const remoteBackendUrl = '../r/uplphoto'; //'uploadFile'
    //const remoteBackendUrl = 'http://127.0.0.1:3000/r/uplphoto';
    //const port = 80;// // 80 // 443; // 8080;
    //const remoteBackendUrl = 'http://localhost:'+port+'/r/uplphoto';
    const remoteBackendUrl = '/r/uplphoto';
    const formData = new FormData();
    console.log('oneGo::user_id', user_id);
    /*
    // Maybe File object cannot be used, at least like this?
    // contents of: `event.target.files[0]`, a `File` object.
    const file = new File(multiPartContent, 'my-photo-name.jpeg', {type: mimeType});
    formData.append('file', file);
    //formData.append('fileName', file.name);
    */

    ////const blob = new Blob([content], { type: "text/xml"});
    //const blob = new Blob([photo], { type: "text/plain"});
    //formData.append('myfile', blob, 'myfilename2.jpg');
    //const blob = new Blob([photo], { type: "text/plain"});

    //works
    formData.append('myfile', photo);
    // received side: .files
    formData.append('user_id', user_id);
    formData.append('user_signature', quick_dirty_string_checksum(user_id));
    // will appear and fields inside `request.body` dict-object.

    console.log('a2');
    // add free form data:
    formData.append('fileName', 'feil-name.jpg');
    console.log('a3');
    const config = {
      headers: {
        'content-type': 'multipart/form-data',
        'Access-Control-Allow-Origin': '*',
        // 'content-type': 'text/json'
      },
      // body: {'ok':'ok'}
    };

    console.log('requesting1.4.10');
    // the sent content is empty.
    const body_ = formData;
    // const body_ = {data:{'bbb': 'bBb'}};
    // const body_ = JSON.stringify({data:{'bbb': 'bBb'}});
    // const body_ = {data:JSON.stringify({'bbb': 'bBb'})};

    try {
      // why was the "body" not sent via POST ?!
      const response = await axios.post(remoteBackendUrl, body_, config);
      // .then((response) => {
      console.log('response from backend: (A)');
      console.log(response.data);
      // see make_error_response() for structure of error contents
      if (response.data.isError) {
        // turn bakend error to front-end error
        throw new Error(response.data.error);
        // ignore response.data.message ?
      }
      // });
    } catch (e) {
      console.error(e);
      alert(e + '');
      /* todo: handle exception from user pov
          (also test catch)
          For a reasonable UX and UX-ops (at least give some feedback so that they can call support)  UX-ops = "support"
      */

    }
  }


  return (
    <div>
      {/*see https://mui.com/material-ui/react-button/*/}

      <IconButton variant="contained"
        size="large" // Doesn't work
        sx={{ fontSize: 140 }}
        onClick={async () => {
          const photo = camera.current.takePhoto();
          setImage(photo);
          //handleChange(photo)
          // DOES NOT WORK: `app_global_state`
          console.warn('global.app_global_state.user_id', global.app_global_state.user_id);
          await oneGo(photo, /*global.app_global_state.user_id*/'sosi' );
        }}>

        <CameraAltIcon size="large" sx={{ fontSize: 140 }} />

      </IconButton>

      {/*<Tooltip title="Switch camera" arrow>
        <Button>...</Button>
      </Tooltip>*/}
      <IconButton
        /* hidden={numberOfCameras <= 1} */
        sx={{ fontSize: 140 }}
        onClick={() => {
          camera.current.switchCamera();
        }}
      >
        {/*switch*/}

        <Cameraswitch size="large" sx={{ fontSize: 140 }} />

      </IconButton>


      <Camera className={classes.mycamm} ref={camera}
        numberOfCamerasCallback={setNumberOfCameras}
        aspectRatio={16 / 9}
        facingMode='environment'
      />

      <img className={classes.mytakenphoto} src={image} alt='Image preview' />

    </div>
  );
}

export { MyCamera };
